<template>
  <div class="container h-screen mx-auto overflow-y-scroll" style="background-color: #FFF7E2">
    <form @submit.prevent="tryToLogIn">
      <KioskBanner />
      <!--end::banner-->

      <div class="flex items-center justify-center text-center">
        <div class="w-full px-10">
          <p class="my-5 text-lg font-bold sm:text-2xl">
            이름과 나이를 통해 <br />
            간단히 입장하세요!
          </p>

          <div class="w-10/12 mx-auto my-5 sm:my-10 sm:w-2/3">
            <BaseFormInput
              v-model="username"
              placeholder="이름"
              type="text"
              name="username"
              class="w-full px-2 py-4 mb-4 text-xl font-bold text-center sm:text-2xl bg color"
            />
            <p v-if="authError && authError.username" class="mb-4 font-bold text-red-700">{{ authError.username }}</p>

            <BaseFormInput
              v-model="age"
              placeholder="나이"
              type="number"
              name="username"
              class="w-full px-2 py-4 mb-4 text-xl font-bold text-center sm:text-2xl bg color"
            />
            <p v-if="authError && authError.age" class="mb-4 font-bold text-red-700">{{ authError.age }}</p>

            <div class="flex mb-4 border">
              <div class="w-1/2">
                <button
                  type="button"
                  class="block w-full h-full py-4 font-bold bg-white border-b-4 rounded-tl rounded-bl"
                  :class="[
                    { 'bg-yellow-500 border-b-4 border-yellow-600 text-white': gender === 'f' },
                    'bg-white border-b-4',
                  ]"
                  @click="gender = 'f'"
                >
                  여성
                </button>
              </div>
              <div class="w-1/2">
                <button
                  type="button"
                  class="block w-full h-full py-4 font-bold bg-white border-b-4 rounded-tr rounded-br"
                  :class="[
                    { 'bg-yellow-500 border-b-4 border-yellow-600 text-white': gender === 'm' },
                    'bg-white border-b-4',
                  ]"
                  @click="gender = 'm'"
                >
                  남성
                </button>
              </div>
            </div>

            <button
              type="submit"
              class="w-full py-4 mx-auto mt-4 text-lg font-bold text-white rounded-full sm:py-5 v:text-3xl sm:text-2xl"
              style="background-color: #3A3534"
            >
              입장하기
            </button>

            <div class="block">
              <hr class="my-5" />

              <button
                type="submit"
                class="px-8 py-4 mx-auto font-semibold tracking-tight text-gray-600 border rounded rounded-full sm:py-5 v:text-2xl sm:text-xl"
                @click="toKiosk"
              >
                건너뛰기
              </button>
            </div>

            <KioskFooter class="py-20" />
            <!--end::footer-->
          </div>

          <div class="h-10"></div>
        </div>
      </div>
      <!--end::content-->
    </form>
  </div>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import { mapGetters } from 'vuex'
import { AUTHS } from '@state/modules/auth'
import KioskBanner from '@components/layout/kiosk-banner.vue'
import KioskFooter from '@components/layout/kiosk-footer.vue'

export default {
  page: {
    title: '로그인',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { KioskFooter, KioskBanner },
  data() {
    return {
      username: '',
      age: '',
      gender: 'f',
      authError: null,
    }
  },
  computed: {
    ...mapGetters(AUTHS.NAME, [AUTHS.GET_CURRENT_USER]),
  },
  beforeMount() {
    if (this.GET_CURRENT_USER) {
      this.$router.push({ name: 'home' })
    }
  },
  methods: {
    ...authMethods,
    toKiosk() {
      this.username = '키오스크'
      this.age = 1
    },
    tryToLogIn() {
      this.authError = {}

      if (!this.username || this.username.length < 1) {
        this.authError.username = '이름을 입력해 주세요'
      }

      if (!this.age || this.age < 1 || this.age > 110) {
        this.authError.age = '나이를 입력해 주세요'
      }

      if (Object.keys(this.authError).length > 0) {
        return
      }

      // Reset the authError if it existed.
      this[AUTHS.LOGIN]({ username: this.username, age: this.age, gender: this.gender }).then(() => {
        // Redirect to the home page
        this.$router.push({ name: 'home' })
      })
    },
  },
}
</script>
